import React from "react"

class SeasonalRatesDataType extends React.Component{
  
  constructor(props) {
    super(props);
  }

  render() {
    if (this.props.row.seasonal_rates && this.props.row.seasonal_rates.length > 0) {
      var seasonal_rates = this.props.row.seasonal_rates.map(function (seasonal_rate) {
        return <li key={seasonal_rate.id}>{seasonal_rate.rate_code}</li>
      });

      return (
        <ul style={{marginBottom: 0}}>{seasonal_rates}</ul>
      );
    } else {
      return null;
    }
  }

};

export default SeasonalRatesDataType